<template>
    <div class="index">

<!--        <div class="new-year-dialog-box">-->
<!--            <van-overlay :show="dialogshow" @click="dialogshow = true">-->
<!--                <div class="wrapper" v-if="dialogshow">-->
<!--                    <img src="~@public/img/newIndex/123456789.jpg" class="dialog-img"/>-->
<!--                </div>-->
<!--            </van-overlay>-->
<!--        </div>-->

        <div class="top-banner">
            <div class="top-one-line">
<!--                <span class="top-title" style="font-size:24px;color:#fbff00;">湖北公安政务服务平台测试环境</span>-->
                <span class="top-title">湖北公安政务服务平台</span>
                <p class="icon-box">
                    <van-icon name="scan" size=".58rem" color="#ffffff" @click.native="openQrsearch"/>
                    <!--<van-icon name="search" size=".58rem" color="#ffffff" @click="searchCl"/>-->
                </p>
            </div>
            <p class="top-two-line">把方便带给群众，把服务交给政府</p>
        </div>
        <!--三个轮换图片-->
        <van-swipe :autoplay="5000">
<!--            <van-swipe-item>-->
<!--                <a href="http://localhost:8888/#/matterGuide/4/4a742b48568c43979dc794429d7e011a"><img src="~@public/img/newIndex/criminal-new.jpg" class="swiper-img"/></a>-->
<!--                <img src="~@public/img/newIndex/criminal-new.jpg" class="swiper-img"/>-->
<!--            </van-swipe-item>-->
<!--            <van-swipe-item>-->
<!--                <img src="~@public/img/newIndex/index_swper_07.png" class="swiper-img"/>-->
<!--                <img src="~@public/img/newIndex/2023new-year.jpg" class="swiper-img"/>-->
<!--            </van-swipe-item>-->
            <van-swipe-item>
                <img src="~@public/img/newIndex/index_swper_08.png" class="swiper-img"/>
            </van-swipe-item>
            <van-swipe-item>
                <img src="~@public/img/newIndex/index_swper_06.png" class="swiper-img"/>
            </van-swipe-item>
            <van-swipe-item>
                <img src="~@public/img/newIndex/index_swper_03.png" class="swiper-img"/>
            </van-swipe-item>
        </van-swipe>
        <!--常用业务 分组事项-->
        <div class="title-line-box">
            <span class="title-label">常用业务</span>
            <router-link tag="span" to="/mattersCenter" class="view-more">查看更多
                <van-icon name="arrow" size=".26rem" color="#B0B7C4"/>
            </router-link>
        </div>
        <div class="business-list">
            <router-link tag="p" to="/" @click.native="insertJump(7)">
                <img src="~@public/img/newIndex/icon_yw_08.png" alt="无犯罪业务">
                <span>无犯罪业务</span>
            </router-link>
            <router-link tag="p" to="/" @click.native="insertJump(3)">
<!--            <router-link tag="p" to="" @click.native="goSsHref()">-->
                                <img src="~@public/img/newIndex/icon_yw_03.png" alt="身份证业务">
<!--                <img src="~@public/img/newIndex/icon_ssp_yw.png" alt="交警随手拍">-->
                <span>身份证业务</span>
            </router-link>
<!--            <router-link tag="p" to="/polinfoquery">-->
<!--                <img src="~@public/img/newIndex/icon_yw_07.png" alt="警情信息查询">-->
<!--                <span>警情信息查询</span>-->
<!--            </router-link>-->


            <router-link tag="p" to="" @click.native="toUrl('/eHp')">
                <img src="~@public/img/newIndex/icon_ssp_yw.png" alt="鄂汇拍">
                <span>鄂汇拍</span>
            </router-link>

            <router-link tag="p" to="" @click.native="toUrl('/antiFraud')">
                <img src="~@public/img/hotApply/icon_fzzx.png" alt="湖北反诈中心">
                <span>湖北反诈中心</span>
            </router-link>

<!--            <router-link tag="p" to="" @click.native="goSsHref()">-->
<!--&lt;!&ndash;                <img src="~@public/img/newIndex/icon_yw_03.png" alt="身份证业务">&ndash;&gt;-->
<!--                <img src="~@public/img/newIndex/icon_ssp_yw.png" alt="交警随手拍">-->
<!--                <span>交警随手拍</span>-->
<!--            </router-link>-->
        </div>
        <div class="business-list">

            <router-link tag="p" to="/" @click.native="insertJump(1)">
                <img src="~@public/img/newIndex/icon_yw_01.png" alt="出生登记">
                <span>出生登记</span>
            </router-link>

            <router-link tag="p" to="/" @click.native="insertJump(2)">
                <img src="~@public/img/newIndex/icon_yw_02.png" alt="迁入登记">
                <span>迁入登记</span>
            </router-link>
            <router-link tag="p" to="/" @click.native="insertJump(4)">
                <img src="~@public/img/newIndex/icon_yw_04.png" alt="居住证业务">
                <span>居住证业务</span>
            </router-link>

            <router-link tag="p" to="/" @click.native="insertJump(5)">
                <img src="~@public/img/newIndex/icon_yw_05.png" alt="驾驶证业务">
                <span>驾驶证业务</span>
            </router-link>
<!--            <router-link tag="p" to="/" @click.native="insertJump(6)">-->
<!--                <img src="~@public/img/newIndex/icon_yw_06.png" alt="机动车业务">-->
<!--                <span>机动车业务</span>-->
<!--            </router-link>-->
<!--            <router-link tag="p" to="/" @click.native="insertJump(7)">-->
<!--                <img src="~@public/img/newIndex/icon_yw_08.png" alt="无犯罪业务">-->
<!--                <span>无犯罪业务</span>-->
<!--            </router-link>-->
<!--            <router-link tag="p" to="/" @click.native="insertJump(8)">-->
<!--                <img src="~@public/img/newIndex/icon_yw_07.png" alt="口岸签证">-->
<!--                <span>口岸签证</span>-->
<!--            </router-link>-->

    </div>
    <!--公示公告-->
    <div class="public-announcement">
      <img src="~@public/img/newIndex/icon_gsgg.png" class="announcement-img"/>
      <div class="announcement-title" v-if="gsggList.length <= 0">
        <div class="announcement-list">
          <span class="list-title">暂无公告</span>
        </div>
      </div>
      <van-swipe :autoplay="5000" :show-indicators="false" vertical class="announcement-title"
                 v-if="gsggList.length > 0">
        <van-swipe-item v-for="(item, index) in gsggList" :key="index">
          <div class="announcement-list" @click="goGsggDetail(item.guid)">
            <span class="list-title">{{ item.title }}</span>
            <p class="announcement-list-rt">
              <span class="list-date">{{ item.publicTime.replace(/-/g, ".") }}</span>
              <van-icon name="arrow" size=".3rem" color="#B0B7C4"/>
            </p>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
<!--    厅长信箱入口-->
    <div class="letter-enter" @click="clickLetter">
      <img class="letter-enter-img" src="../../assets/images/letter/enter.png">
    </div>
    <!--我的证件-->
    <div class="title-line-box">
      <span class="title-label">我的证件</span>
      <router-link tag="span" to="/electronicCertificate" class="view-more">查看更多
        <van-icon name="arrow" size=".26rem" color="#B0B7C4"/>
      </router-link>
    </div>
    <div class="certificate-list">

      <router-link tag="p" :to="idCardList['08'].url">
        <img src="~@public/img/newIndex/icon_zj_01.png" alt="身份证">
        <span class="certificate-state">{{ idCardList['08'].status }}</span>
        <span class="certificate-name">{{ idCardList['08'].name }}</span>
        <span class="certificate-num">身份证:{{ idCardList['08'].cardNum }}</span>
      </router-link>

      <router-link tag="p" :to="idCardList['04'].url">
        <img src="~@public/img/newIndex/icon_zj_04.png" alt="户口簿">
        <span class="certificate-state">{{ idCardList['04'].status }}</span>
        <span class="certificate-name">{{ idCardList['04'].name }}</span>
        <span class="certificate-num">户口簿:{{ idCardList['04'].cardNum }}</span>
      </router-link>

        <router-link tag="p" :to="idCardList['09'].url">
            <img src="~@public/img/newIndex/icon_zj_09.png" alt="武汉居住证">
            <span class="certificate-state">{{ idCardList['09'].status }}</span>
            <span class="certificate-name">{{ idCardList['09'].name }}</span>
            <span class="certificate-num">武汉居住证:{{ idCardList['09'].cardNum }}</span>
        </router-link>

      <router-link tag="p" :to="idCardList['06'].url">
        <img src="~@public/img/newIndex/icon_zj_02.png" alt="驾驶证">
        <span class="certificate-state">{{ idCardList['06'].status }}</span>
        <span class="certificate-name">{{ idCardList['06'].name }}</span>
        <span class="certificate-num">驾驶证:{{ idCardList['06'].cardNum }}</span>
      </router-link>


      <router-link tag="p" :to="idCardList['03'].url">
        <img src="~@public/img/newIndex/icon_zj_08.png" alt="行驶证">
        <span class="certificate-state">{{ idCardList['03'].status }}</span>
        <span class="certificate-name">{{ idCardList['03'].name }}</span>
        <span class="certificate-num">行驶证:{{ idCardList['03'].cardNum }}</span>
      </router-link>

      <router-link tag="p" :to="idCardList['05'].url">
        <img src="~@public/img/newIndex/icon_zj_07.png" alt="护照">
        <span class="certificate-state">{{ idCardList['05'].status }}</span>
        <span class="certificate-name">{{ idCardList['05'].name }}</span>
        <span class="certificate-num">护照:{{ idCardList['05'].cardNum }}</span>
      </router-link>

<!--      <router-link tag="p" :to="idCardList['01'].url">-->
<!--        <img src="~@public/img/newIndex/icon_zj_06.png" alt="港澳通行证">-->
<!--        <span class="certificate-state">{{ idCardList['01'].status }}</span>-->
<!--        <span class="certificate-name">{{ idCardList['01'].name }}</span>-->
<!--        <span class="certificate-num">港澳通行证:{{ idCardList['01'].cardNum }}</span>-->
<!--      </router-link>-->

<!--      <router-link tag="p" :to="idCardList['02'].url">-->
<!--        <img src="~@public/img/newIndex/icon_zj_05.png" alt="台湾通行证">-->
<!--        <span class="certificate-state">{{ idCardList['02'].status }}</span>-->
<!--        <span class="certificate-name">{{ idCardList['02'].name }}</span>-->
<!--        <span class="certificate-num">台湾通行证:{{ idCardList['02'].cardNum }}</span>-->
<!--      </router-link>-->

<!--      <router-link tag="p" :to="idCardList['07'].url">-->
<!--        <img src="~@public/img/newIndex/icon_zj_03.png" alt="居住证">-->
<!--        <span class="certificate-state">{{ idCardList['07'].status }}</span>-->
<!--        <span class="certificate-name">{{ idCardList['07'].name }}</span>-->
<!--        <span class="certificate-num">居住证:{{ idCardList['07'].cardNum }}</span>-->
<!--      </router-link>-->
    </div>
    <ul class="nav-list">
      <router-link tag="li" to="/mattersCenter">
        <img src="~@public/img/newIndex/icon_nav_01.png" alt="我要办事">
        <p>
          <span>我要办事</span>
          <span>事项办理</span>
        </p>
      </router-link>
      <router-link tag="li" to="/MyHandlingList">
        <img src="~@public/img/newIndex/icon_nav_03.png" alt="我的办件">
        <p>
          <span>我的办件</span>
          <span>事项审批记录</span>
        </p>
      </router-link>
      <router-link tag="li" to="/advisoryFrom">
        <img src="~@public/img/newIndex/icon_nav_02.png" alt="我要咨询">
        <p>
          <span>我要咨询</span>
          <span>事项办理咨询</span>
        </p>
      </router-link>
      <router-link tag="li" to="/MyEvaluationList">
        <img src="~@public/img/newIndex/icon_nav_04.png" alt="我要评价">
        <p>
          <span>我要评价</span>
          <span>事项办理评价</span>
        </p>
      </router-link>
    </ul>
    <!--        <router-link to="/clueReport">-->
    <!--            <img class="img-prompt" src="~@public/img/newIndex/icon_prompt.png" alt="提示栏">-->
    <!--        </router-link>-->
    <div class="title-line-box">
      <span class="title-label">热门应用</span>
      <router-link tag="span" to="/hotApply" class="view-more">查看更多
        <van-icon name="arrow" size=".26rem" color="#B0B7C4"/>
      </router-link>
    </div>
    <ul class="hot-app-list">

      <router-link tag="li" to="/matterGuide/1/00699a292c28401c89da654f2caa3b68">
        <img src="~@public/img/newIndex/icon_app_07.png" alt="武汉-大学毕业生落户">
        <p>迁入登记</p>
        <span>武汉-大学毕业生落户</span>
      </router-link>

      <router-link tag="li" to="/" @click.native="goHref">
        <img src="~@public/img/hotApply/zhifagk.png" alt="执法公开">
        <p>执法公开</p>
        <span>执法公开查询</span>
      </router-link>

      <router-link tag="li" to="/" @click.native="openQrsearch">
        <img src="~@public/img/newIndex/icon_app_010.png" alt="扫一扫">
        <p>证照核验</p>
        <span>证件二维码<br/>扫一扫</span>
      </router-link>

      <router-link tag="li" to="" @click.native="login122('p00000000000000000005')">
        <img src="~@public/img/hotApply/icon_wfcl.png" alt="交通违法处理">
        <p>违法处理</p>
        <span>交通违法处理</span>
      </router-link>

      <router-link tag="li" to="" @click.native="login122('p00000000000000000014')">
        <img src="~@public/img/hotApply/icon_wfjf.png" alt="交通违法缴费">
        <p>违法缴费</p>
        <span>交通违法缴费</span>
      </router-link>

      <router-link tag="li" to="" @click.native="login122('p00000000000000000024')">
        <img src="~@public/img/hotApply/icon_kckp.png" alt="快撤理赔">
        <p>快撤理赔</p>
        <span>快撤理赔</span>
      </router-link>

      <router-link tag="li" to="/lllegalQuery">
        <img src="~@public/img/newIndex/icon_app_05.png" alt="机动车查询">
        <p>机动车查询</p>
        <span>机动车违章查询</span>
      </router-link>

      <router-link tag="li" to="/licenseQuery">
        <img src="~@public/img/newIndex/icon_app_01.png" alt="驾驶证查询">
        <p>驾驶证查询</p>
        <span>驾驶证记分查询</span>
      </router-link>

      <router-link tag="li" to="/idQuery">
        <img src="~@public/img/newIndex/icon_app_02.png" alt="身份证查询">
        <p>身份证查询</p>
        <span>身份证办理进度查询</span>
      </router-link>

<!--      <router-link tag="li" to="/moveCar">-->
<!--            <img src="~@public/img/newIndex/icon_app_06.png" alt="堵路移车">-->
<!--            <p>堵路移车</p>-->
<!--            <span>堵路移车查询</span>-->
<!--      </router-link>-->

<!--      <router-link tag="li" to="" @click.native="jzz()">-->
<!--        <img src="~@public/img/newIndex/icon_app_04.png" alt="户口查询">-->
<!--        <p>户口查询</p>-->
<!--        <span>户口办理进度查询</span>-->
<!--      </router-link>-->

<!--        <router-link tag="li" to="/" @click.native="toUrl('/eHp')">-->
<!--            <img src="~@public/img/hotApply/icon_ssp.png" alt="鄂汇拍">-->
<!--            <p>鄂汇拍</p>-->
<!--            <span>鄂汇拍</span>-->
<!--        </router-link>-->

    </ul>
<!--    厅长信箱 选择 弹窗-->
    <van-popup class="letter-popup" v-model="showLetter">
      <div class="letter-pop">
        <div class="close" @click="showLetter=false"></div>
        <div class="half-lf" @click="toIndex"></div>
        <div class="half-rt" @click="toDialog"></div>
      </div>
    </van-popup>
    <van-popup class="choose-popup" v-model="showChoose">
      <div class="choose-pop">
        <p class="title">请选择城市</p>
        <span class="close" @click="showChoose=false"></span>
        <div class="choose-city">
          <div class="each" v-for="(item,index) in areaList" :key="item.areaCode"
               @click="goletterbox(item,index)">{{ item.name }}
          </div>
        </div>
      </div>
    </van-popup>
      <!--投诉举报弹窗-->
      <van-dialog v-model="dialogVisible" title="投诉须知" @confirm="tsjbJump" show-cancel-button>
        <div class="tsjb-dialog-wrap">
          <h2>一、投诉范围</h2>
          <p>本政务移动互联网应用程序(以下简称政务应用程序)涉及到的“指尖上的形式主义”有关问题。</p>
          <h2>二、投诉内容</h2>
          <p>1.强制下载推广。强制推广下载本政务应用程序，限定用户安装使用率。</p>
          <p>2.强制打卡签到。设置打卡签到功能(除安保、应急等特殊规定外)，脱离工作实际强制要求打卡接龙、即时响应,随意摊派任务、索要材料。</p>
          <p>3.滥用排名。将本政务应用程序的积分排名、在线时长相关数据向用户和个人开放或用于通报排名和考评。滥用本政务应用程序的关注点赞、转发评论功能，将其作为考核评价、评比评选的依据甚至通报、约谈。</p>
          <p>4.过度留痕。把本政务应用程序作为工作考核日常化、督导检查线上化的载体,随意要求下级和基层单位通过本政务应用程序频繁上传图片或视频,简单以工作留痕评价实际工作成效。</p>
          <h2>三、注意事项</h2>
          <p>1.举报人应对举报事项的客观性、真实性负责。</p>
          <p>2.举报人请勿就同一事项重复举报。</p>
          <p>3.原则上于10个工作日内将处理情况向投诉人予以反馈。</p>
        </div>
      </van-dialog>
  </div>
</template>

<script>
import {Icon, Swipe, SwipeItem, Toast, Dialog, Overlay,Popup } from 'vant';
import {newsApiMap} from "@/api/news";
import {queryApiMap} from "@/api/query";
import {wechatApi} from '@/api/wechat'
import {memberApi} from '@/api/member'
import {Source} from '@/utils/source'
import Bridge from '@/utils/bridge'

export default {
  components: {
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Overlay.name]: Overlay,
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      showChoose:false,
      showLetter:false,
      areaList: [
        {
          name: '武汉市',
          areaCode: 420100,
          headerImg:'wh'
        },
        {
          name: '黄石市',
          areaCode: 420200,
          headerImg:'hs'
        },
        {
          name: '十堰市',
          areaCode: 420300,
          headerImg:'sy'
        },
        {
          name: '宜昌市',
          areaCode: 420500,
          headerImg:'yc'
        },
        {
          name: '襄阳市',
          areaCode: 420600,
          headerImg:'xy'
        },
        {
          name: '鄂州市',
          areaCode: 420700,
          headerImg:'ez'
        },
        {
          name: '荆门市',
          areaCode: 420800,
          headerImg:'jm'
        },
        {
          name: '孝感市',
          areaCode: 420900,
          headerImg:'xg'
        },
        {
          name: '荆州市',
          areaCode: 421000,
          headerImg:'jz'
        },
        {
          name: '黄冈市',
          areaCode: 421100,
          headerImg:'hg'
        },
        {
          name: '咸宁市',
          areaCode: 421200,
          headerImg:'xn'
        },
        {
          name: '随州市',
          areaCode: 421300,
          headerImg:'sz'
        },
        {
          name: '恩施州',
          areaCode: 422800,
          headerImg:'es'
        },
        {
          name: '仙桃市',
          areaCode: 429004,
          headerImg:'xt'
        },
        {
          name: '潜江市',
          areaCode: 429005,
          headerImg:'qj'
        },
        {
          name: '天门市',
          areaCode: 429006,
          headerImg:'tm'
        },
        {
          name: '神农架林区',
          areaCode: 429021,
          headerImg:'snj'
        },
        {
          name: '江汉油田',
          areaCode: 429007,
          headerImg:'jhyt'
        }
      ],
      dialogshow:true,
      gsggList: [], // 公示公告信息
      idCardList: {
        '01': {
          name: '***',
          cardNum: "******************",
          status: '暂无',
          url: '/HKMPermit'
        },
        '02': {
          name: '***',
          cardNum: "******************",
          status: '暂无',
          url: '/TWPermit'
        },
        '03': {
          name: '***',
          cardNum: "******************",
          status: '暂无',
          url: '/drivingLicense'
        },
        '04': {
          name: '***',
          cardNum: "******************",
          status: '暂无',
          url: '/residenceBooklet'
        },
        '05': {
          name: '***',
          cardNum: "******************",
          status: '暂无',
          url: '/protection'
        },
        '06': {
          name: '***',
          cardNum: "******************",
          status: '暂无',
          url: '/driverLicense'
        },
        '07': {
          name: '***',
          cardNum: "******************",
          status: '暂无',
          url: '/residencePermit'
        },
        '08': {
          name: '***',
          cardNum: "******************",
          status: '暂无',
          url: '/idCard'
        },
        '09': {
          name: '***',
          cardNum: "******************",
          status: '暂无',
          url: '/Mindaugas'
        },
      },
      dialogVisible:false,//投诉举报弹窗

    }
  },
  mounted() {
    let url = encodeURIComponent(window.location.href.split('#')[0]);
    this.$httpUtils.getCommonUtils(wechatApi.signature + '?url=' + url).then((res) => {
      let result = res.data;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: result.appid, // 必填，公众号的唯一标识
        timestamp: result.timestamp, // 必填，生成签名的时间戳
        nonceStr: result.noncestr, // 必填，生成签名的随机串
        signature: result.signature,// 必填，签名
        jsApiList: ["scanQRCode"] // 必填，需要使用的JS接口列表
      });
      wx.error((res) => {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        console.log('出错了');
      });

      wx.ready(() => {
        wx.checkJsApi({
          jsApiList: ['scanQRCode'],
          success: function (res) {
            console.log(res)
          }
        });
      });
    }).catch((err) => {
      console.log(err)
      console.log('获取 signature 失败')
    });
    // 获取公示公告列表数据
    this.getAnnouncementListInfo()
    this.listQueryIdData()
    this.logger.visit('1000', '0')
  },
  methods: {
    /**打开投诉举报弹窗**/
    openTsjbDialog(){
      this.dialogVisible=true
    },
    /**投诉举报跳转**/
    tsjbJump(){
      this.dialogVisible=false
      this.$router.push("/clueReport")
    },
    clickLetter(){
      this.showLetter=true
    },
    toIndex(){
        this.$httpUtils.getCommonUtils(`/consults/mail/visit?type=2`).then(res => {
        })
      this.showLetter=false
      this.currentCity = 420000
      this.$httpUtils.getCommonUtils(`/consults/mail/leadership?regionalId=${this.currentCity}`).then(res => {
        const cityInfo={
          regionalId:res.data.data.regionalId,
          regionalName:res.data.data.regionalName,
        }
        this.$store.commit('GET_CITY',cityInfo)
        this.$router.push({
          path: '/letter',
          query: {headerImg:'hb'}
        })
      })
    },
    toDialog(){
      this.showLetter=false
      this.showChoose=true
    },
    //跳转到确认信息展示弹框
    goletterbox(item) {
        this.$httpUtils.getCommonUtils(`/consults/mail/visit?type=2`).then(res => {

        })
      if (item) {
        this.currentCity = item.areaCode
      } else {
        this.currentCity = 420000
      }
      this.$httpUtils.getCommonUtils(`/consults/mail/leadership?regionalId=${this.currentCity}`).then(res => {
      const cityInfo={
        regionalId:res.data.data.regionalId,
        regionalName:res.data.data.regionalName,
      }
        console.log(cityInfo,'cityInfo');
        this.$store.commit('GET_CITY',cityInfo)
        this.$router.push({
          path: '/letter',
          query: {headerImg:item.headerImg}
        })
      })
      this.showChoose = false
    },


      jzz() {
          Toast.fail('功能服务维护中，暂停使用！！！')
      },

      goHref() {
              window.location.href = 'http://223.76.234.78:9999/zfgk-vx/'
      },


    goSsHref() {
      window.location.href = 'https://cloud-4ga5tibs44b35540-1256139749.tcloudbaseapp.com/'
    },

      goFzzxHref() {
          window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI0MDUxNTI3Mg==#wechat_redirect'
      },

      // 几个长按二维码扫描的功能
      toUrl(url) {
          let source = Source.getSource()
          if (source !== 'WEI') {
              Toast('请在微信端打开！')
              return false
          }
          this.$router.push(url)
      },

    insertJump(val) {
      // 点击进入事项列表添加标识
      window.sessionStorage.setItem('matterJump', 'Y')
      let pcc = '';
      let guid = "";
      let alt = "";
      let log = "";
      switch (val) {
        case 1:
          pcc = "1";
          guid = "74b3774e402546cbb4d6457fbaa98783";
          alt = "出生登记";
          log = "305"
          break;
        case 2:
          pcc = "1";
          guid = "8085fdf92a4243fda4938258c5a668b1";
          alt = "迁入登记";
          log = "306"
          break;
        case 3:
          pcc = "1";
          guid = "9b662cf6a028447ab149017f8366e9e7";
          alt = "身份证业务";
          log = "307"
          break;
        case 4:
          pcc = "1";
          guid = "e44a4385cb0c483998f406227be60300";
          alt = "居住证业务";
          log = "308"
          break;
        case 5:
          pcc = "6";
          guid = "dd01a09ca11543ce8f7c8a18d02652f9";
          alt = "驾驶证业务";
          log = "301"
          break;
        case 6:
          pcc = "6";
          guid = "865ce5df434b492993eb8fe8706bcd95";
          alt = "机动车业务";
          log = "302"
          break;
        case 7:
          // pcc = "5";
          // guid = "8135c6ae3514451fad55ed6e3dae1e39";
          // alt ="护照业务";
          // log = "303"
          pcc = "4";
          guid = "761be67995f24fc79af85da088c696ef";
          alt = "无犯罪业务";
          log = "303"
          break;
        case 8:
          pcc = "5";
          guid = "02ca3dd2fede4bd2b5aeec0991ccb09d";
          alt = "口岸签证";
          log = "304"
          break;
        default:

      }
      this.$router.push({path: "/matterListByGroup", query: {pcc: pcc, guid: guid, alt: alt}})
      this.logger.visit(log, '0', guid)
    },
    searchCl() {
      this.$router.push({path: '/ServiceList'})
    },
    listQueryUrlMap() {
      const urlMap = {
        // 01-港澳通行证，02-台湾通行证，03-电子行驶证，04-电子户口簿，05-电子护照，
        // 06-电子驾驶证，07-电子居住证，08-电子身份证
        '01': '/HKMPermit',
        '02': '/TWPermit',
        '03': '/drivingLicense',
        '04': '/residenceBooklet',
        '05': '/protection',
        '06': '/driverLicense',
        '07': '/residencePermit',
        '08': '/idCard',
        '09': '/Mindaugas'
      }
      return urlMap
    },
    /**
     * 获取证件列表简略信息
     */
    listQueryIdData() {
      const url = queryApiMap.queryIdList
      this.$httpUtils.getGatewayUtils(url).then(res => {
        if (res.data.succ) {
          this.idCardList = res.data.data
        }
        const urlMap = this.listQueryUrlMap()
        for (let key in this.idCardList) {
          if (this.idCardList[key].name === '***') {
            this.idCardList[key].status = '暂无'
            this.idCardList[key].url = urlMap[key]
          } else {
            this.idCardList[key].status = '正常'
            this.idCardList[key].url = urlMap[key]
          }
        }
      })
    },
    /**
     * 获取公示公告信息
     */
    getAnnouncementListInfo() {
      const data = {
        ps: '3',
        pi: 1,
        category: 'gsgg',
      };
      this.$httpUtils.getCommonUtils(newsApiMap.newsPage, data).then(res => {
        if (res.data.succ) {
          this.gsggList = res.data.data.list
        }
      }).catch(error => {
        console.log(error)
      })
    },
    /**
     * 跳转到公示公告详情页面
     */
    goGsggDetail(id) {
      // this.$router.push('/announcementDetails?id=' + id);
      this.$router.push('/announcementList');
    },
    /**
     * 微信二维码扫一扫
     */
    openQrsearch() {
      let source = Source.getSource()
      if (source === 'IOS') {
        // 调用ios扫描二维码
        Bridge.callhandler('goNewVC', {"newPath": '', "newVC": "scan"}, (data) => {
        });
      } else if (source === 'ANDROID') {
        // 调用安卓扫描二维码
      } else {
        // 微信
        wx.scanQRCode({
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
          success: (res) => {
            if ((res.resultStr).slice(0, 12) === "HBWSGAJLogin") {//验证扫码登录二维码
              this.$router.push("/ytj-login/" + (res.resultStr).slice(12)) //截取二维码随机的guid
            } else if ((res.resultStr).length == 32) {
              this.$router.push("/qrCriminalRecord/" + res.resultStr)
            } else {
              let result = JSON.parse(res.resultStr);
              if (result.type == '01') {
                this.$router.push("/qrhkm/" + result.token);
              }
              if (result.type == '02') {
                this.$router.push("/qrtw/" + result.token);
              }
              if (result.type == '03') {
                this.$router.push("/qrdriving/" + result.token);
              }
              if (result.type == '04') {
                this.$router.push("/qrbooklet/" + result.token);
              }
              if (result.type == '05') {
                this.$router.push("/qrprotection/" + result.token);
              }
              if (result.type == '06') {
                this.$router.push("/qrdriverLicense/" + result.token);
              }
              if (result.type == '07') {
                this.$router.push("/qrresidence/" + result.token);
              }
              if (result.type == '08') {
                this.$router.push("/qridcard/" + result.token);
              }
              if (result.type == '09') {
                this.$router.push("/whResidencePermit/" + result.token);
              }
            }
            // window.location.href = result;
          }
        });
      }

    },
    /**
     * 122单点
     */
    login122(productId) {
      if (this.$cookie.getUser() && this.$cookie.getUser().guid) {
        Toast.loading({
          duration: 0,       // 持续展示 toast
          forbidClick: true, // 禁用背景点击
          loadingType: 'spinner',
          message: '加载中...'
        })
        let url = memberApi.login122 + '?productId=' + productId;
        this.$httpUtils.getGatewayUtils(url).then((res) => {
          console.log(res);
          if (res.data && res.data.succ) {
            Toast.clear()
            window.location.href = res.data.data;
          } else {
            Toast.clear()
            Dialog.alert({
              message: '该服务正在建设中，敬请期待'
            }).then(() => {
              // on close
            });
          }
        }).catch((err) => {
          console.log(err)
          Toast.fail('服务异常')
        });
      } else {
        this.$router.push('/login')
      }
    }
  }
}
</script>
<style>
.new-year-dialog-box {
  z-index: 10000;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  z-index: 10000;
}

.dialog-img {
  width: 100%;
}

.dialog-close {
  width: 42px;
}

.van-swipe__indicator {
  width: .06rem;
  height: .06rem;
  background: #1349DD;
}

.van-swipe__indicator--active {
  width: .36rem;
  height: .06rem;
  background: #1349DD;
  border-radius: 0;
}
</style>
<style lang="less" scoped>
/*.grey {*/
/*  filter: grayscale(100%);*/
/*  !*-webkit-filter: grayscale(100%);*!*/
/*  !*-moz-filter: grayscale(100%);*!*/
/*  !*-ms-filter: grayscale(100%);*!*/
/*  !*-o-filter: grayscale(100%);*!*/
/*  !*-webkit-filter: grayscale(1);*!*/
/*}*/

.letter-enter{
  padding: 0 .2rem;
  margin-bottom:.2rem;
  .letter-enter-img{
    width: 100%;
  }
}
/deep/.letter-popup{
  background: transparent;
}

.letter-pop{
  width: 6.64rem;
  height: 3.5rem;
  background: url('.././../assets/images/letter/choose.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
  .close, .half-lf, .half-rt{
    position: absolute;
  }

  .close{
    right: .2rem;
    top: .2rem;
    width: .5rem;
    height: .5rem;
  }
  .half-lf, .half-rt{
    width: 2.12rem;
    height: .8rem;
    top: 1.84rem;
  }
  .half-lf{
    left: .96rem;
  }
  .half-rt{
    right: .96rem;
  }
}
/deep/.choose-popup{
  background: transparent;
  .choose-pop{
    position: relative;
    background: linear-gradient(110deg, #D8E4FF 0%, #E8F2FF 46%, #F1F9FF 100%);
    width: 8.6rem;
    padding: 0 .24rem;
    border-radius: .266rem;
    box-sizing: border-box;

    .choose-city{
      display: flex;
      flex-wrap: wrap;
      .each{
        border: 1px solid #1566B8;
        font-size: .37rem;
        padding:.13rem  .26rem;
        margin-right: .3rem;
        margin-bottom: .4rem;
        border-radius: .13rem;
        color: #1566B8;
      }
    }
  }
  .title{
   color: #333;
    font-size: .37rem;
    padding: .36rem 0 .46rem;
    //margin-bottom: .46rem;
    //margin-top: .2rem;
  }
  .close{
    width: .56rem;
    height: .56rem;
    background: url("../.././assets/images/letter/close.png") no-repeat;
    position: absolute;
    right: .2rem;
    top: .26rem;
  }
}
/*投诉举报弹窗*/
.tsjb-dialog-wrap{
  padding: .2rem .4rem;
}
.tsjb-dialog-wrap h2{
  font-size: .32rem;
  font-weight: bold;
  line-height: .7rem;
  text-indent: .6rem;
}
.tsjb-dialog-wrap p{
  font-size: .28rem;
  line-height: .54rem;
  text-indent: .6rem;
}
@import "../../assets/css/views/index/NewIndex.less";
</style>
